/* eslint-disable id-length */
import keyMirror from 'keymirror';

export default keyMirror({
  LOAD_PRODUCTS: null,
  PRODUCTS_WERE_LOADED: null,
  PRODUCT_DETAILS_WERE_LOADED: null,
  LOAD_DETAILED_PRODUCTS: null,
  SET_PRODUCT_SLUG: null,
  SET_PRODUCT_DETAIL_DATA: null,
  LOAD_PRODUCT: null,
  PRODUCT_WAS_LOADED: null,
  SET_PRODUCT_CONFIG: null,
  ERROR_LOADING_PRODUCTS_DATA: null,
  ERROR_LOADING_PRODUCT_DATA: null,
  LOAD_SIMILAR_PRODUCTS: null,
  LOAD_SIMILAR_PRODUCTS_LOADED: null,
  ERROR_LOADING_SIMILAR_PRODUCTS_DATA: null
});
